// Summary Component
// Built for Checkout and Confirmation pages
// Styling based heavily on BookingSummary used on Modify Booking

import React, { Component } from 'react';

import ModalActionCreator from 'action_creators/modal';
import {
  toNumber,
  toCurrency,
} from 'views/anyguide/bookings/cancel/v2/utilities/utilities';

// Load base css from BookingSummary
import 'views/anyguide_bookings/modify_booking/BookingSummary.scss';
import './Summary.scss';

class Summary extends Component {
  showCancellationPolicy = (e) => {
    // const cancellationPolicy = this.props.tour.cancellation_policy.description;
    const { cancellationPolicyText } = this.props.checkoutData.tour;

    const modalContent = (
      <div className="cancellationPolicyModal">
        <div className="title">REDEMPTION DETAILS</div>
        <div className="policy">
          {' '}
          {cancellationPolicyText.split('\n').map((text) => {
            return <p>{text}</p>;
          })}
        </div>
      </div>
    );

    const modalSettings = {
      content: modalContent,
      triggeringElement: e.currentTarget,
    };

    ModalActionCreator.show(modalSettings);
  };

  renderUnits = () => {
    const { pricing, tour } = this.props.checkoutData;
    const units = pricing.units.map((unit) => {
      if (unit.quantity > 0) {
        return (
          <span key={unit.name}>
            {tour.currency}
            {unit.price} x {unit.quantity} {unit.name}
          </span>
        );
      }
      return null;
    });

    return units;
  };

  render() {
    const { name, image, currency, cancellationPolicyText } =
      this.props.checkoutData.tour;
    const {
      total,
      subtotal,
      // serviceFee,
      units,
    } = this.props.checkoutData.pricing;
    const numberOfGuests = units.reduce((acc, obj) => {
      return acc + obj.quantity;
    }, 0);

    return (
      <div className="bookingSummary">
        <div
          className="coverPicture"
          style={{ backgroundImage: `url('${image}')` }}
        />
        <div className="infoPanel">
          <div className="tourName">{name}</div>
          <div className="businessName">Warner Bros.</div>
          <div className="details">
            <div className="detail">
              <span className="detailType">Number of Guests</span>
              <span className="value">{numberOfGuests}</span>
            </div>
          </div>
          <div className="cancellationPolicy">
            <span className="title">Redemption Details</span>
            <a className="policyName" onClick={this.showCancellationPolicy}>
              {`${cancellationPolicyText.substring(0, 17).trim()}...`}
            </a>
          </div>
          <div className="priceBreakdown">
            <span className="total">Total</span>
            <span className="totalAmount">{toCurrency(total, currency)}</span>
          </div>
          <div className="subtotalBreakdown">
            <span className="label">Subtotal</span>
            <span className="amount">{toCurrency(subtotal, currency)}</span>
          </div>
          <span className="units">{this.renderUnits()}</span>
        </div>
      </div>
    );
  }
}

export default Summary;
